import Image from "next/image";
import { Flex, Box, Text } from "rebass/styled-components";
import FormatDate from "../common/FormatDate";
import theme from "../../styles/theme";
import styles from "../../styles/articleStyle";
import useTranslation from "next-translate/useTranslation";
import { InferredComment, InferredCommmentAuthor } from "../../types";
import ReactHtmlParser from "react-html-parser";

interface Props {
  comments: InferredComment[];
  isMobile: boolean;
}

function Comments(props: Props) {
  const { comments, isMobile } = props;
  const { t } = useTranslation("common");

  const renderComment = (comment: InferredComment, index: number) => {
    const author: InferredCommmentAuthor = comment.author?.node || {};
    return (
      <Flex key={index} sx={styles.comments.container}>
        <Flex sx={styles.comments.authorAndDate}>
          <Flex sx={styles.comments.auhtorInfo}>
            <Box sx={styles.comments.userPicBox}>
              <Box sx={styles.comments.userPic}>
                <Image
                  src={author.avatar?.url || ""}
                  alt={author.name || ""}
                  loading="lazy"
                  width="100%"
                  height="100%"
                  layout="responsive"
                />
              </Box>
            </Box>

            <Box sx={{ width: "100%" }}>
              <Text as="h4" sx={styles.comments.author}>
                {author.name}
              </Text>
            </Box>
          </Flex>

          {isMobile && (
            <Box sx={{ width: ["50%", "50%", "0px"] }}>
              <Text as="p" sx={{ ...styles.comments.date, textAlign: "right" }}>
                <FormatDate date={comment.date || ""} />
              </Text>
            </Box>
          )}
        </Flex>

        <Flex sx={styles.comments.contentSection}>
          {!isMobile && (
            <Text as="p" sx={styles.comments.date}>
              <FormatDate date={comment.date || ""} />
            </Text>
          )}
          <Text as="p" sx={styles.comments.content}>
            {ReactHtmlParser(comment.content || "")}
          </Text>
        </Flex>
      </Flex>
    );
  };

  return (
    <Box sx={{ my: "24px" }}>
      <Text as="h3" sx={{ ...theme.title, mb: "16px" }}>
        {t("comments")}
      </Text>

      {comments.length === 0 ? (
        <Text as="p" sx={{ ...theme.description, textAlign: "left" }}>
          {t("noComments")}
        </Text>
      ) : (
        <Flex sx={{ flexDirection: "column", gap: "32px" }}>
          {comments.map((comment, index) => renderComment(comment, index))}
        </Flex>
      )}
    </Box>
  );
}

export default Comments;
